import { FORCE_ACTIONS } from '../actions';
import { ForceState } from '../state';

export const updateForcesBatchReducer = (state: ForceState, { forces }: ReturnType<typeof FORCE_ACTIONS.UPDATE_FORCES_BATCH>) => {
    // Create a map of force updates for O(1) lookup
    const updateMap = new Map(forces.map((f) => [f.id, f]));

    const updatedForces = state.forces.map((f) => {
        const update = updateMap.get(f.id);
        if (!update) {
            return f;
        }

        // Merge the update into the existing force
        const merged = { ...f, ...update };

        // Preserve the newer updatedAt timestamp to prevent sync conflicts.
        if (f.updatedAt && update.updatedAt) {
            merged.updatedAt = Math.max(f.updatedAt, update.updatedAt);
        }

        return merged;
    });

    const newState = {
        ...state,
        forces: updatedForces
    };

    return newState;
};
